import { useMemo } from 'react';
import { Translate } from '../../../../../../../shared/LanguageService';
import { ICost } from '../../../../../../../shared/localization/currency';

type UseConfirmModalTextArgs = {
    extraImageCount: number;
    extraImageCost: ICost | null;
};

export function useImageApprovalConfirmationText({
    extraImageCount,
    extraImageCost
}: UseConfirmModalTextArgs): string {
    let confirmModalText = useMemo(
        function () {
            let extraImages = extraImageCount.toString();
            let extraImagesSingle = Translate(
                'image-processing/page/status-actions/warning-text/extra-single'
            );
            let extraImagesMultiple = Translate(
                'image-processing/page/status-actions/warning-text/extra-multiple'
            );

            let formattedCount =
                extraImageCount > 1
                    ? extraImages + ' ' + extraImagesMultiple
                    : extraImages + ' ' + extraImagesSingle;

            if (extraImageCount > 0 && extraImageCost !== null) {
                return Translate('image-processing/page/status-actions/warning-text-with-price', {
                    numberOfExtraImages: formattedCount,
                    costOfExtraImages: extraImageCost.toString(
                        extraImageCount * extraImageCost.value
                    )
                });
            }

            if (extraImageCount > 0) {
                let warningText = Translate('image-processing/page/status-actions/warning-text');
                return warningText.toString().replace('#numberOfExtraImages', formattedCount);
            }

            return Translate('image-processing/page/status-actions/warning-text-no-extra');
        },
        [extraImageCount, extraImageCost]
    );

    return confirmModalText;
}
